export const networkDomains = {
  Mainnet: "https://myth.finance",
  Testnet: "https://testnet.myth.finance",
  Fnet: "https://fnet.myth.finance",
};

export const changeNetwork = (network: string) => {
  if (network in networkDomains) {
    // @ts-ignore
    window.location.href = networkDomains[network];
  } else {
    throw new Error("Invalid network");
  }
};